exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unfair-content[data-v-507252a8] {\n  padding: 15px;\n}\n.unfair-list[data-v-507252a8] {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.unfair-title[data-v-507252a8] {\n  border-bottom: 1px solid #ddd;\n}\n", ""]);

// exports
